/**
 * Real-time multiplayer asteroids game with TypeScript/Bun server and HTML5 Canvas client
 * Lobby domain - Empty state component for when no lobbies are available
 */

import type React from "react";

export const EmptyState: React.FC = () => {
  return (
    <div className="lobby-list-empty">
      <span>No active lobbies found</span>
      <small>Click REFRESH to check for lobbies</small>
    </div>
  );
};
